export const init = () => {
  /* SHOPPING TOOL - LAST VIEWED PRODUCTS */

  const fwk = CUBE.Analytics;
  const sep = AnalyticsConstants.separatorST;

  const stType = 'merchandising-cart';

  if (tc_vars.env_template !== 'checkout') return;

  // 'savelaterGoBackToProduct' -- CLICK - to product page
  let event = CUBE.Analytics.utils.getEvent('savelaterGoBackToProduct');
  if (event) {
    event.postAction(function handler() {
      const model = this.model;
      fwk.shoppingtool.set(
        stType,
        `savelater${sep}position${sep}${model.position}`
      );
    });
  }

  // 'removeToSaveLater' -- ADDTOCART
  event = CUBE.Analytics.utils.getEvent('removeFromSaveLater');
  if (event) {
    event.postAction(function handler($element) {
      const model = this.model;

      fwk.shoppingtool.setTmp(
        stType,
        `savelater${sep}position${sep}${model.position}`,
        this.getLabel($element),
        this.getValue($element)
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-save-later.js